import { createSlice } from '@reduxjs/toolkit'

export const byoSlice = createSlice({
  name: 'byo',
  initialState: Object.assign(
    {
      step: 1,
      color: 0,
      material: 0,
      materialSelected: 0,
      addons: [],
      addons2: [],
      addonSeleted: null,
      addon2Seleted: null,
    },
    localStorage.getItem('app_state') ? JSON.parse(localStorage.getItem('app_state')) : {},
  ),
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setColor: (state, action) => {
      state.color = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    selectMaterial: (state, action) => {
      state.materialSelected = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setMaterial: (state, action) => {
      state.material = action.payload
      state.materialSelected = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    selectAddon: (state, action) => {
      state.addonSeleted = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    selectAddon2: (state, action) => {
      state.addon2Seleted = action.payload
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    setAddon: (state, action) => {
      const existingAddon = state.addons.filter(
        (addon) => addon.productId == action.payload.productId && addon.variantId == action.payload.variantId,
      )
      if (existingAddon.length > 0) state.addons.splice(state.addons.indexOf(existingAddon[0]), 1)
      else state.addons.push(action.payload)
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    clearState: (state) => {
      state.step = 1
      state.color = 0
      state.material = 0
      state.materialSelected = 0
      state.addons = []
      state.addons2 = []
      state.addonSeleted = null
      state.addon2Seleted = null
      localStorage.setItem('app_state', JSON.stringify(state))
    },
    clearOtherSteps: (state) => {
      state.material = 0
      state.materialSelected = 0
      state.addons = []
      state.addons2 = []
      state.addonSeleted = null
      state.addon2Seleted = null
      localStorage.setItem('state', JSON.stringify(state))
    },
  },
})

export const {
  setStep,
  setColor,
  selectMaterial,
  setMaterial,
  setAddon,
  selectAddon,
  selectAddon2,
  clearState,
  clearOtherSteps,
} = byoSlice.actions

export default byoSlice.reducer
